module.exports = __webpack_public_path__ + "static/media/logofull3.5b1815fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/logofull3.png
// module id = 392
// module chunks = 0